import { AxiosInstance } from "axios";
import { API_URL_PROJECTS } from "constants/api_urls";
import { makeQueryString } from "core/makeQueryString";
import { IProject } from "interfaces/project";

export const getCheckProjectNameExists = async (
  axios: AxiosInstance,
  projectName: string
): Promise<boolean> =>
  projectName.trim()
    ? axios
        .get<{ count: number; results: IProject[] }>(
          `${API_URL_PROJECTS}${
            projectName ? makeQueryString({ name: projectName }) : ""
          }`
        )
        .then(r => r.data.count > 0)
    : Promise.resolve(false);
